import { destroy, get, post } from '../utils/request';
import { credentials } from './user';

export const handleFetchCompanyLogo = (user) => async (dispatch) => {
  try {
    const response = await get('/company_logo', dispatch, credentials(user));

    const body = await response.json();

    const { url } = body;

    dispatch(setCompanyLogoUrl(url));

    return true;
  } catch (error) {
    return false;
  }
};

// Le code de réponse était ignoré : un refus du serveur (format, poids) renvoyait
// quand même « vrai », l'écran annonçait « Enregistré avec succès » et posait une
// URL vide — le logo disparaissait de l'aperçu sans un mot d'explication. Le
// message du serveur remonte donc tel quel : lui seul dit quoi corriger.
export const handleImportCompanyLogo = (params, user) => async (dispatch) => {
  try {
    const response = await post('/company_logo', params, dispatch, credentials(user));

    const body = await response.json();

    if (!response.ok || body.error) return { ok: false, error: body.error };

    dispatch(setCompanyLogoUrl(body.url));

    return { ok: true };
  } catch (error) {
    return { ok: false };
  }
};

// Retirer le logo (≠ le remplacer). Même lecture du code de réponse que l'import :
// on ne vide l'aperçu que si le serveur a vraiment purgé, sinon l'écran mentirait.
export const handleDeleteCompanyLogo = (user) => async (dispatch) => {
  try {
    const response = await destroy('/company_logo', dispatch, credentials(user));

    const body = await response.json();

    if (!response.ok || body.error) return { ok: false, error: body.error };

    dispatch(setCompanyLogoUrl(null));

    return { ok: true };
  } catch (error) {
    return { ok: false };
  }
};

export const setCompanyLogoUrl = (url) => ({
  type: 'SET_COMPANY_LOGO_URL',
  url,
});
